import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findIndex, path } from 'ramda';

import styles from './styles.m.scss';
import { calculatePercent } from '../../util/helpers';

import Card from '../Card';

function getHighestStep(stepName, steps) {
  let highestStep = findIndex((step) => path(['props', 'name'], step) == stepName, steps);
  if (highestStep == -1) {
    highestStep = 0;
  }
  return highestStep;
}

class Accordion extends Component {
  static propTypes = {
    children: PropTypes.any,
    finishBtn: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    onPercentageChanged: PropTypes.func,
  };

  constructor(props) {
    super(props);

    const { onPercentageChanged } = props;
    const totalSteps = React.Children.count(props.children);
    const highestStep = getHighestStep(props.step, props.children);

    onPercentageChanged && onPercentageChanged(calculatePercent(highestStep, totalSteps));
    this.state = {
      totalSteps,
      currentStep: highestStep,
      highestStep,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const totalSteps = React.Children.count(nextProps.children);
    const highestStep = getHighestStep(nextProps.step, nextProps.children);

    return { totalSteps, highestStep };
  }

  setStep = (stepNumber) => {
    const { onPercentageChanged } = this.props;
    const { highestStep, totalSteps } = this.state;

    onPercentageChanged && onPercentageChanged(calculatePercent(stepNumber, totalSteps));
    this.setState({ currentStep: stepNumber, highestStep: highestStep > stepNumber ? highestStep : stepNumber });
  };

  render() {
    const { children, step, ...props } = this.props;
    const { totalSteps } = this.state;
    const childrenWithSteps = React.Children.map(children, (child, i) => {
      const accordionStep = React.cloneElement(child, { step: i, setStep: this.setStep, ...props, ...this.state });
      const isLastStep = i === totalSteps - 1;

      return isLastStep ? (
        accordionStep
      ) : (
        <div>
          {accordionStep}
          <hr />
        </div>
      );
    });

    return (
      <Card>
        <Card.Body>{childrenWithSteps}</Card.Body>
      </Card>
    );
  }
}

export default Accordion;
